import { useMutation } from '@tanstack/react-query';
import { serverPersist, type QuizOptions } from '../data/server-persist';
import { type Quiz } from '../quiz-hooks';

interface Params {
  customerId: number;
  quiz: Quiz;
  options?: QuizOptions;
}

export function useServerPersist() {
  return useMutation({
    mutationFn: async (params: Params) => {
      const { customerId, quiz, options } = params;
      return await serverPersist(customerId, quiz, { ...options });
    },
  });
}
